<script lang="ts" setup>
import { defineProps } from 'vue'
import GwBox from '@/components/lib/GwBox/GwBox.vue'
import GwBtn from '@/components/lib/GwBtn/GwBtn.vue'
import { t } from '@/locales/i18n'
import {
  displayAsRaise,
  type ActionSequence,
} from '@/components/lib/GwTable/ActionSequence/actionSequenceUtils'
import GwText from '@/components/lib/base/GwText/GwText.vue'

interface ActionsFilterSequenceProps {
  sequence: ActionSequence
  hasTitle?: boolean
}

defineProps<ActionsFilterSequenceProps>()

const emit = defineEmits<{
  'trim:sequence': [number]
}>()
</script>

<template>
  <div class="d-flex">
    <div class="d-flex flex-column ga-2">
      <GwText
        v-if="hasTitle"
        variant="text_white_medium_700"
        >{{ t('hhv3.filter.actions_sequence.title') }}</GwText
      >
      <div
        v-if="sequence.length"
        class="d-flex"
        style="gap: var(--app-gap-2)"
      >
        <GwBox
          v-for="(actions, i) in sequence"
          :key="actions[0]"
          variant="box_select_pill_primary"
          class="f-center position-relative gw_hvr cursor-pointer"
          :class="{ 'anim-bounce': i === sequence.length - 1 }"
          @click="emit('trim:sequence', i)"
        >
          <span
            v-html="
              actions
                .map(a =>
                  t(`hhv3.filter.actions_sequence.btn_line.${a}`, {
                    bet_type: displayAsRaise(sequence, i) ? 'R' : 'B',
                  }),
                )
                .join(' / ')
            "
          />

          <GwBtn
            icon="mdi-close"
            style="position: absolute; right: 0; transform: translate(60%, 0); color: black"
            variant="btn_primary-v2-small"
            class="gw_hvr_content"
          />
        </GwBox>
      </div>
    </div>
  </div>
</template>
